import { render, staticRenderFns } from "./StaffBlockTime.vue?vue&type=template&id=4f4fc668"
import script from "./StaffBlockTime.vue?vue&type=script&lang=js"
export * from "./StaffBlockTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports